import { apiClient } from '../../axios';
import { GetRewardHubV2Response } from './types';

export const getRewardHubV2Api = () => apiClient.get<GetRewardHubV2Response>('/v1/reward-hub-v2');
export const claimRewardHubV2Api = ({ sectionIndex, missionIndex }: { sectionIndex: number; missionIndex: number }) =>
  apiClient.post('/v1/reward-hub-v2/claim', { sectionIndex, missionIndex });
